import { render, staticRenderFns } from "./chooseCity.vue?vue&type=template&id=63167c80&"
import script from "./chooseCity.vue?vue&type=script&lang=js&"
export * from "./chooseCity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports